<template>
  <v-container>
   <v-row>
      <v-col
        xs="12"
      >
        <v-card>
          <v-card-title class="headline">Histórico de Atendimentos</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="filters.search"  
              label="Pesquisar atendimento"
              @input="setAttendingHistorySearch"              
            ></v-text-field>
            <HistoryPagination
              @changePage="changePage"
              :pagination="pagination"
              :pages="pages"
            />
            <AttendingCard 
              v-for="subattending in $store.state.attending_history.data" 
              :subattending="subattending"
              :key="subattending.id"
              :scheduleAction="true"
              @openScheduleDialog="openScheduleDialog"
            />
            <HistoryPagination 
              @changePage="changePage"
              :pagination="pagination"
              :pages="pages"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <CreateSchedule            
      @closeDialog="closeDialog"  
      :dialog="dialog"
      :subattending="transaction"
    />

  </v-container>  
</template>

<script>
  import CreateSchedule from '../Attending/schedule/Create';
  import AttendingCard from './AttendingCard';
  import HistoryPagination from './HistoryPagination';
  export default {
    name: 'index',
    components: {
      AttendingCard,
      HistoryPagination,
      CreateSchedule
    },
    created() {
      this.$store.dispatch('fetchAttendingHistory', this.$route.params.uuid)
    },
    computed: {
      pages () {
        if (this.$store.state.attending_history.total === 0) {
          return 0;
        }
        return Math.ceil(this.$store.state.attending_history.total / this.$store.state.attending_history.per_page)
      }
    },
    methods: {
      changePage(page) {        
        this.$store.commit('setAttendingHistoryPage', page);
        this.$store.dispatch('fetchAttendingHistory', this.$route.params.uuid)
      },
      setAttendingHistorySearch() {
        if (this.prevSearch) {
          clearTimeout(this.prevSearch);
        }
        this.prevSearch = setTimeout( () => this.$store.dispatch('setAttendingHistorySearch', this.filters.search, this.$route.params.uuid)

        , 500);
      },
      closeDialog() {
        this.dialog = false
      },
      openScheduleDialog(transaction)  {
        this.transaction = transaction
        this.dialog = true;
      }
    },
    data () {
      return {
        filters: {
          search: ''
        },
        transaction: null,
        dialog: false,
        pagination: {
          descending: false,
          page: this.$store.state.attending_history.current_page,
          rowsPerPage: this.$store.state.attending_history.per_page,
          sortBy: '',
          totalItems: this.$store.state.attending_history.total
        }    
      }
    }
  }
</script>

<style lang="css" scoped>
</style>